import React from 'react';
import ReactSVG from 'react-svg';

export default class EventIcon extends React.PureComponent {

    render() {
        var classList = ['event-icon'];
        switch (this.props.type) {
            case 'START':
                classList.push('start');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol" src="/svg/timeline-icon-start-green.svg" />
                    </i>
                );
            case 'END':
                classList.push('end');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol" src="/svg/timeline-icon-start-purple.svg" />
                    </i>
                );
            case 'EVENT_ENGINE_ON':
                classList.push('parking');
                classList.push('parking-ended');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-teardrop.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-parking.svg" />
                    </i>
                );
            case 'EVENT_ENGINE_OFF':
                classList.push('parking');
                classList.push('parking-started');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-teardrop-up.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-parking.svg" />
                    </i>
                );
            case 'EVENT_SPEEDING_MERGED':
                classList.push('speeding');
                classList.push('speeding-merged');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-circle.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-speeding.svg" />
                    </i>
                );
            case 'EVENT_SPEEDING_STARTED':
                classList.push('speeding');
                classList.push('speeding-started');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-teardrop-up.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-speeding.svg" />
                    </i>
                );
            case 'EVENT_SPEEDING_STOPPED':
                classList.push('speeding');
                classList.push('speeding-stopped');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-teardrop.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-speeding.svg" />
                    </i>
                );
            case 'EVENT_IDLING_MERGED':
                classList.push('idling');
                classList.push('idling-merged');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-circle.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-idling.svg" />
                    </i>
                );
            case 'EVENT_IDLING_STARTED':
                classList.push('idling');
                classList.push('idling-started');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-teardrop-up.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-idling.svg" />
                    </i>
                );
            case 'EVENT_IDLING_STOPPED':
                classList.push('idling');
                classList.push('idling-stopped');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-teardrop.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-idling.svg" />
                    </i>
                );
            case 'EVENT_HARD_BRAKING':
                classList.push('hard-braking');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-circle.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-warning.svg" />
                    </i>
                );
            case 'EVENT_RAVEN_GEOFENCE_ENTER':
            case 'EVENT_RAVEN_GEOFENCE_EXIT':
                classList.push('geofence');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-circle.svg" />
                        <i className='material-icons'>bubble_chart</i>
                    </i>
                );
            // TODO: dynamically import from `src/data/events/configurations/` based on event type
            //       But, doing so does not capture all AI event types yet (e.g. )
            case 'EVENT_RAVEN_CAMERA_OBSCURED':
            case 'EVENT_RAVEN_CELLPHONE_DETECTED':
            case 'EVENT_RAVEN_DISTRACTED_DETECTED':
            case 'EVENT_RAVEN_DRINKING_DETECTED':
            case 'EVENT_RAVEN_EATING_DETECTED':
            case 'EVENT_RAVEN_POTENTIAL_RED_LIGHT_CAMERA_VIOLATION':
            case 'EVENT_RAVEN_POTENTIAL_SPEED_CAMERA_VIOLATION':
            case 'EVENT_RAVEN_SMOKING_DETECTED':
            case 'EVENT_RAVEN_STOP_SIGN_VIOLATION':
            case 'EVENT_RAVEN_TIRED_DETECTED':
            case 'EVENT_RAVEN_VISION_TAILGATING':
                classList.push('ai-event');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-circle.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-ai-event.svg" />
                    </i>
                );
            case 'EVENT_DEMO_DS4_ALARM_ON':
                classList.push('urgent');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-circle.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-car-alarm.svg" />
                    </i>
                );
            case 'EVENT_ACCIDENT':
            case 'EVENT_POSSIBLE_IMPACT':
            case 'EVENT_OBD_DTC_ALERT':
            case 'EVENT_OBD_DTC_CLEARED':
            case 'EVENT_RAVEN_BAD_INSTALL_DETECTED':
            case 'EVENT_RAVEN_BAD_INSTALL_CLEARED':
                classList.push('urgent');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-circle.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-warning.svg" />
                    </i>
                );
            default:
                classList.push('warning');
                return (
                    <i className={classList.join(' ')}>
                        <ReactSVG svgClassName="symbol-bg" src="/svg/icon-circle.svg" />
                        <ReactSVG svgClassName="symbol" src="/svg/icon-warning.svg" />
                    </i>
                );
        }
    }
}
